"use client";
import useHasCookieConsent from "@/lib/client/useHasCookieConsent";
import Script from "next/script";


//#region [Props]
type GTMScriptProps = {
    gtmId: string;
    isConsentEnabled: boolean;
};
//#endregion

//#region [Component]
export default function GTMScript({ gtmId, isConsentEnabled }: GTMScriptProps) {
    const [hasConsent] = useHasCookieConsent();

    if (isConsentEnabled && !hasConsent) {
        return null;
    }
    return <>
        <Script id="google-tag-manager" strategy='afterInteractive'>
            {`
						(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
						new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
						j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
						'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
						})(window,document,'script','dataLayer','${gtmId}');
						`}
        </Script>
        <noscript dangerouslySetInnerHTML={{ __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>` }}></noscript>
    </>;
}
//#endregion